/*
* @license
* Pipeline Theme (c) Groupthought Themes
*
* The contents of this file should not be modified.
* add any minor changes to assets/custom.js
*
*/
!(function (e, t, i, o, n, s, r, a, l, c, d, h) {
    "use strict";
    function u(e) {
        const t = e.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        t.forEach((e) => {
            i.querySelector(`[id="${e.id}"]`) || i.appendChild(e);
        });
    }
    (window.theme = window.theme || {}), (window.theme.sizes = { small: 480, medium: 768, large: 990, widescreen: 1400 }), (window.theme.keyboardKeys = { TAB: 9, ENTER: 13, ESCAPE: 27, SPACE: 32, LEFTARROW: 37, RIGHTARROW: 39 });
    const p = ["neighbor--white", "neighbor--light", "neighbor--dark", "neighbor--black"];
    function y(e) {
        e.querySelectorAll("shopify-section").forEach((e) => {
            e.classList.remove(p);
        }),
            e.querySelectorAll(".section:not(.bg--accent)").forEach((e) => {
                e.parentElement.classList.add("neighbor--white");
            }),
            e.querySelectorAll(".section--light.bg--accent").forEach((e) => {
                e.parentElement.classList.add("neighbor--light");
            }),
            e.querySelectorAll(".section--dark:not(.bg--accent)").forEach((e) => {
                e.parentElement.classList.add("neighbor--dark");
            }),
            e.querySelectorAll(".section--dark.bg--accent").forEach((e) => {
                e.parentElement.classList.add("neighbor--black");
            });
    }
    function f(e) {
        e.querySelectorAll(".float__wrapper").forEach((e) => {
            const t = e.querySelector("label");
            e.querySelector("input, textarea").addEventListener("keyup", (e) => {
                "" !== e.target.value ? t.classList.add("label--float") : t.classList.remove("label--float");
            });
        });
    }
    function m() {
        const e = {};
        return (
            (e.windowHeight = window.innerHeight),
            (e.announcementHeight = v('[data-section-type*="announcement"]')),
            (e.footerHeight = v('[data-section-type*="footer"]')),
            (e.menuHeight = v("[data-header-height]")),
            (e.headerHeight = e.menuHeight + e.announcementHeight),
            (e.logoHeight = (function () {
                const e = v("[data-footer-logo]");
                return e > 0 ? e + 20 : 0;
            })()),
            e
        );
    }
    function g() {
        document.addEventListener("theme:resize", w),
            (function () {
                const { windowHeight: e, announcementHeight: t, headerHeight: i, logoHeight: o, menuHeight: n, footerHeight: s } = m();
                document.documentElement.style.setProperty("--full-screen", e + "px"),
                    document.documentElement.style.setProperty("--three-quarters", e * (3 / 4) + "px"),
                    document.documentElement.style.setProperty("--two-thirds", e * (2 / 3) + "px"),
                    document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
                    document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
                    document.documentElement.style.setProperty("--one-fifth", e / 5 + "px"),
                    document.documentElement.style.setProperty("--menu-height", n + "px"),
                    document.documentElement.style.setProperty("--announcement-height", t + "px"),
                    document.documentElement.style.setProperty("--header-height", i + "px"),
                    document.documentElement.style.setProperty("--footer-height", s + "px"),
                    document.documentElement.style.setProperty("--content-full", e - i - o / 2 + "px"),
                    document.documentElement.style.setProperty("--content-min", e - i - s + "px");
            })();
    }
    function w() {
        const { windowHeight: e, announcementHeight: t, headerHeight: i, logoHeight: o, menuHeight: n, footerHeight: s } = m();
        document.documentElement.style.setProperty("--menu-height", n + "px"),
            document.documentElement.style.setProperty("--announcement-height", t + "px"),
            document.documentElement.style.setProperty("--header-height", i + "px"),
            document.documentElement.style.setProperty("--footer-height", s + "px"),
            document.documentElement.style.setProperty("--content-full", e - i - o / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", e - i - s + "px");
    }
    function v(e) {
        const t = document.querySelector(e);
        return t ? t.clientHeight : 0;
    }
    function b(e, t) {
        let i = 0;
        t.forEach((e) => {
            e.offsetHeight > i && (i = e.offsetHeight);
        });
        const o = e.querySelectorAll("[data-overflow-background]");
        [e, ...o].forEach((e) => {
            e.style.setProperty("min-height", i + 64 + "px");
        });
    }
    function T(e) {
        if (window.innerWidth <= window.theme.sizes.medium) {
            return void e.querySelectorAll("[data-overflow-frame]").forEach((e) => {
                const t = e.querySelectorAll("[data-overflow-content]");
                b(e, t);
            });
        }
        let t = 0;
        const i = e.querySelectorAll("[data-overflow-frame]");
        e.querySelectorAll("[data-overflow-content]").forEach((e) => {
            e.offsetHeight > t && (t = e.offsetHeight);
        });
        const o = e.querySelectorAll("[data-overflow-background]");
        [e, ...i, ...o].forEach((e) => {
            e.style.setProperty("min-height", t + 64 + "px");
        });
    }
    function k(e) {
        const t = e.querySelectorAll(".preventOverflow");
        t &&
            t.forEach((e) => {
                const t = e.querySelectorAll(".preventOverflowContent");
                b(e, t),
                    document.addEventListener("theme:resize", () => {
                        b(e, t);
                    });
            });
        const i = e.querySelectorAll("[data-overflow-wrapper]");
        i &&
            i.forEach((e) => {
                T(e),
                    document.addEventListener("theme:resize", () => {
                        T(e);
                    });
            });
    }
    function E(e, t) {
        let i;
        return function () {
            const o = () => e.apply(this, arguments);
            clearTimeout(i), (i = setTimeout(o, t));
        };
    }
    let S = window.pageYOffset,
        _ = null,
        L = null,
        A = null,
        x = null;
    function $() {
        document.body.style = "overflow-y:hidden; position: relative;";
    }
    function C() {
        document.body.style = "overflow-y:visible; position: static;";
    }
    window.addEventListener(
        "resize",
        E(function () {
            document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 }));
        }, 50)
    ),
        (function () {
            let e;
            window.addEventListener(
                "scroll",
                function () {
                    e && window.cancelAnimationFrame(e),
                        (e = window.requestAnimationFrame(function () {
                            !(function () {
                                const e = window.pageYOffset;
                                e > S ? ((L = !0), (_ = !1)) : e < S ? ((L = !1), (_ = !0)) : ((_ = null), (L = null)),
                                    (S = e),
                                    document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: _, down: L, position: e }, bubbles: !1 })),
                                    _ && !A && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: e }, bubbles: !1 })),
                                    L && !x && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: e }, bubbles: !1 })),
                                    (x = L),
                                    (A = _);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", $),
                window.addEventListener("theme:scroll:unlock", C);
        })(),
        window.addEventListener("load", () => {
            g(), f(document), u(document), y(document), k(document);
        }),
        document.addEventListener("shopify:section:load", (e) => {
            const t = e.target;
            f(t), u(t), y(t), k(t);
        }),
        e("#AddAddress").length &&
            (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
            e(".address-country-option").each(function () {
                var t = e(this).data("form-id"),
                    i = "AddressCountry_" + t,
                    o = "AddressProvince_" + t,
                    n = "AddressProvinceContainer_" + t;
                new Shopify.CountryProvinceSelector(i, o, { hideElement: n });
            }),
            e(".address-new-toggle").on("click", function () {
                e("#AddAddress").toggleClass("hide");
            }),
            e(".address-edit-toggle").on("click", function () {
                var t = e(this).data("form-id");
                e("#EditAddress_" + t).toggleClass("hide");
            }),
            e(".address-delete").on("click", function () {
                var t = e(this),
                    i = t.data("form-id"),
                    o = t.data("confirm-message");
                confirm(o || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + i, { parameters: { _method: "delete" } });
            })),
        e("#RecoverPassword").length &&
            (function () {
                var t = { recoverPasswordForm: "#RecoverPassword", hideRecoverPasswordLink: "#HideRecoverPasswordLink" };
                function i(e) {
                    e.preventDefault(), n();
                }
                function o() {
                    "#recover" === window.location.hash && n();
                }
                function n() {
                    var t = e("#CustomerEmail").val();
                    e("#RecoverEmail").val(t), e("#RecoverPasswordForm").toggleClass("hide"), e("#CustomerLoginForm").toggleClass("hide");
                }
                function s() {
                    e(".reset-password-success").length && e("#ResetSuccess").removeClass("hide");
                }
                o(), s(), e(t.recoverPasswordForm).on("click", i), e(t.hideRecoverPasswordLink).on("click", i);
            })();
    const q = {};
    function P(t = {}) {
        if (t.url)
            return q[t.url]
                ? q[t.url]
                : (function (t) {
                      const i = new Promise((i, o) => {
                          e.getScript(t)
                              .done(function (e) {
                                  i(e);
                              })
                              .fail(function (e) {
                                  o(e);
                              });
                      });
                      return (q[t] = i), i;
                  })(t.url);
        if (t.json)
            return q[t.json]
                ? Promise.resolve(q[t.json])
                : window
                      .fetch(t.json)
                      .then((e) => e.json())
                      .then((e) => ((q[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return q[e]
                ? q[e]
                : (function (e) {
                      const t = "".concat(e.name, e.version),
                          i = new Promise((t, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: e.name,
                                          version: e.version,
                                          onLoad: (e) => {
                                              !(function (e, t, i) {
                                                  i ? t(i) : e();
                                              })(t, i, e);
                                          },
                                      },
                                  ]);
                              } catch (e) {
                                  i(e);
                              }
                          });
                      return (q[t] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    function j(e) {
        t.init({ openTrigger: "data-popup-" + e, disableScroll: !0 });
    }
    e(".js-toggle-login-modal").length && (j("password"), e(".storefront-password-form .errors").length && e(".js-toggle-login-modal").click()),
        e("#QrCode").length &&
            (function () {
                var t = { qrCode: "#QrCode", printButton: "#PrintGiftCard", giftCardCode: ".giftcard__code" },
                    i = e(t.qrCode);
                function o(e) {
                    var t = document.getElementById(e.data.element),
                        i = "";
                    if (document.body.createTextRange) (i = document.body.createTextRange()).moveToElementText(t), i.select();
                    else if (window.getSelection) {
                        var o = window.getSelection();
                        (i = document.createRange()).selectNodeContents(t), o.removeAllRanges(), o.addRange(i);
                    }
                }
                new QRCode(i[0], { text: i.attr("data-identifier"), width: 120, height: 120 }),
                    e(t.printButton).on("click", function () {
                        window.print();
                    }),
                    e(t.giftCardCode).on("click", { element: "GiftCardDigits" }, o);
            })();
    var D = "data-section-id";
    function O(e, t) {
        (this.container = (function (e) {
            if (!(e instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
            if (null === e.getAttribute(D)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");
            return e;
        })(e)),
            (this.id = e.getAttribute(D)),
            (this.extensions = []),
            Object.assign(
                this,
                (function (e) {
                    if ((void 0 !== e && "object" != typeof e) || null === e) throw new TypeError("Theme Sections: The properties object provided is not a valid");
                    return e;
                })(t)
            );
        try {
            this.onLoad();
        } catch (e) {
            console.warn("Error in section: " + this.id), console.warn(this), console.warn(e);
        }
    }
    (O.prototype = {
        onLoad: Function.prototype,
        onUnload: Function.prototype,
        onSelect: Function.prototype,
        onDeselect: Function.prototype,
        onBlockSelect: Function.prototype,
        onBlockDeselect: Function.prototype,
        extend: function (e) {
            this.extensions.push(e);
            var t = Object.assign({}, e);
            delete t.init, Object.assign(this, t), "function" == typeof e.init && e.init.apply(this);
        },
    }),
        "function" != typeof Object.assign &&
            Object.defineProperty(Object, "assign", {
                value: function (e) {
                    if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                    for (var t = Object(e), i = 1; i < arguments.length; i++) {
                        var o = arguments[i];
                        if (null != o) for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
                    }
                    return t;
                },
                writable: !0,
                configurable: !0,
            });
    var I = "data-section-type";
    (window.Shopify = window.Shopify || {}), (window.Shopify.theme = window.Shopify.theme || {}), (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
    var H = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        F = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    function B(e, t) {
        if ("string" != typeof e) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== H[e]) throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        function i(e) {
            for (var i = 0; i < t.length; i++) O.call(this, e, t[i]);
        }
        return Array.isArray(t) || (t = [t]), (i.constructor = O), (i.prototype = Object.create(O.prototype)), (i.prototype.type = e), (H[e] = i);
    }
    function z(e, t) {
        (e = V(e)),
            void 0 === t && (t = document.querySelectorAll("[data-section-type]")),
            (t = W(t)),
            e.forEach(function (e) {
                var i = H[e];
                void 0 !== i &&
                    (t = t.filter(function (t) {
                        return !(M(t).length > 0) && null !== t.getAttribute(I) && (t.getAttribute(I) !== e || (F.push(new i(t)), !1));
                    }));
            });
    }
    function M(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var i = e[0];
        if (e instanceof Element || i instanceof Element)
            W(e).forEach(function (e) {
                t = t.concat(
                    F.filter(function (t) {
                        return t.container === e;
                    })
                );
            });
        else if ("string" == typeof e || "string" == typeof i) {
            V(e).forEach(function (e) {
                t = t.concat(
                    F.filter(function (t) {
                        return t.type === e;
                    })
                );
            });
        }
        return t;
    }
    function U(e) {
        for (var t, i = 0; i < F.length; i++)
            if (F[i].id === e) {
                t = F[i];
                break;
            }
        return t;
    }
    function V(e) {
        return (
            "*" === e
                ? (e = Object.keys(H))
                : "string" == typeof e
                ? (e = [e])
                : e.constructor === O
                ? (e = [e.prototype.type])
                : Array.isArray(e) &&
                  e[0].constructor === O &&
                  (e = e.map(function (e) {
                      return e.prototype.type;
                  })),
            (e = e.map(function (e) {
                return e.toLowerCase();
            }))
        );
    }
    function W(e) {
        return (
            NodeList.prototype.isPrototypeOf(e) && e.length > 0
                ? (e = Array.prototype.slice.call(e))
                : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
                ? (e = [])
                : !Array.isArray(e) && e instanceof Element && (e = [e]),
            e
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (e) {
            var t = e.detail.sectionId,
                i = e.target.querySelector('[data-section-id="' + t + '"]');
            null !== i && z(i.getAttribute(I), i);
        }),
        document.addEventListener("shopify:section:unload", function (e) {
            var t = e.detail.sectionId,
                i = e.target.querySelector('[data-section-id="' + t + '"]');
            "object" == typeof M(i)[0] &&
                M(i).forEach(function (e) {
                    var t = F.map(function (e) {
                        return e.id;
                    }).indexOf(e.id);
                    F.splice(t, 1), e.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (e) {
            var t = U(e.detail.sectionId);
            "object" == typeof t && t.onSelect(e);
        }),
        document.addEventListener("shopify:section:deselect", function (e) {
            var t = U(e.detail.sectionId);
            "object" == typeof t && t.onDeselect(e);
        }),
        document.addEventListener("shopify:block:select", function (e) {
            var t = U(e.detail.sectionId);
            "object" == typeof t && t.onBlockSelect(e);
        }),
        document.addEventListener("shopify:block:deselect", function (e) {
            var t = U(e.detail.sectionId);
            "object" == typeof t && t.onBlockDeselect(e);
        }));
    var R = {};
    const N = {
        onLoad() {
            R[this.id] = [];
            this.container.querySelectorAll("[data-parallax-wrapper]").forEach((e) => {
                const t = e.querySelector("[data-parallax-img]");
                R[this.id].push(new i(t, { center: !0, round: !0, frame: e }));
            });
        },
        onUnload: function () {
            R[this.id].forEach((e) => {
                "function" == typeof e.destroy && e.destroy();
            });
        },
    };
    B("article", N);
    const K = "data-popdown-toggle",
        Y = "[data-close-popdown]",
        J = "[data-focus-input]",
        Q = "is-visible";
    let G = {};
    class X {
        constructor(e) {
            (this.trigger = e), (this.key = this.trigger.getAttribute(K));
            const t = `[id='${this.key}']`;
            (this.popdown = document.querySelector(t)), (this.input = this.popdown.querySelector(J)), (this.close = this.popdown.querySelector(Y)), this.initTriggerEvents(), this.initPopdownEvents();
        }
        initTriggerEvents() {
            this.trigger.setAttribute("aria-haspopup", !0),
                this.trigger.setAttribute("aria-expanded", !1),
                this.trigger.setAttribute("aria-controls", this.key),
                this.trigger.addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault(), this.showPopdown();
                    }.bind(this)
                ),
                this.trigger.addEventListener(
                    "keyup",
                    function (e) {
                        e.which === window.theme.keyboardKeys.SPACE && this.showPopdown();
                    }.bind(this)
                );
        }
        initPopdownEvents() {
            this.popdown.addEventListener(
                "keyup",
                function (e) {
                    e.which === window.theme.keyboardKeys.ESCAPE && this.hidePopdown();
                }.bind(this)
            ),
                this.close.addEventListener(
                    "click",
                    function () {
                        this.hidePopdown();
                    }.bind(this)
                );
        }
        hidePopdown() {
            this.popdown.classList.remove(Q), this.trigger.focus();
        }
        showPopdown() {
            this.popdown.classList.add(Q), this.input.focus();
        }
    }
    const Z = {
            onLoad() {
                G[this.id] = {};
                const e = this.container.querySelector(`[${K}]`);
                e && (G[this.id] = new X(e));
            },
            onUnload: function () {
                "function" == typeof G[this.id].unload && G[this.id].unload();
            },
        },
        ee = "[data-ticker-frame]",
        te = "[data-ticker-scale]",
        ie = "[data-ticker-text]",
        oe = "data-clone",
        ne = "ticker--animated",
        se = "ticker--unloaded",
        re = "ticker__comparitor",
        ae = {};
    class le {
        constructor(e) {
            (this.frame = e),
                (this.scale = this.frame.querySelector(te)),
                (this.text = this.frame.querySelector(ie)),
                (this.comparitor = this.text.cloneNode(!0)),
                this.comparitor.classList.add(re),
                this.frame.appendChild(this.comparitor),
                this.scale.classList.remove(se),
                this.listen();
        }
        unload() {
            document.removeEventListener("theme:resize", this.checkWidth);
        }
        listen() {
            document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth();
        }
        checkWidth() {
            if (this.frame.clientWidth < this.comparitor.clientWidth)
                this.text.classList.add(ne), 1 === this.scale.childElementCount && ((this.clone = this.text.cloneNode(!0)), this.clone.setAttribute("aria-hidden", !0), this.clone.setAttribute(oe, ""), this.scale.appendChild(this.clone));
            else {
                let e = this.scale.querySelector(`[${oe}]`);
                e && this.scale.removeChild(e), this.text.classList.remove(ne);
            }
        }
    }
    B("announcement", [
        {
            onLoad() {
                ae[this.id] = [];
                this.container.querySelectorAll(ee).forEach((e) => {
                    ae[this.id].push(new le(e));
                });
            },
            onUnload: function () {
                ae[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        Z,
    ]),
        B("blog", N);
    var ce = "[data-drawer]",
        de = "[data-drawer-underlay]",
        he = "[data-stagger-animation]",
        ue = "data-drawer-toggle",
        pe = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        ye = "drawer--visible",
        fe = "display-none",
        me = {};
    class ge {
        constructor(e) {
            (this.drawer = e), (this.underlay = this.drawer.querySelector(de)), (this.key = this.drawer.dataset.drawer);
            const t = `[${ue}='${this.key}']`;
            (this.buttons = document.querySelectorAll(t)), (this.staggers = this.drawer.querySelectorAll(he)), this.connectToggle(), this.connectDrawer(), this.closers(), this.staggerChildAnimations();
        }
        unload() {}
        connectToggle() {
            this.buttons.forEach((e) => {
                e.addEventListener(
                    "click",
                    function () {
                        this.drawer.dispatchEvent(new CustomEvent("theme:menu:toggle", { bubbles: !1 }));
                    }.bind(this)
                );
            });
        }
        connectDrawer() {
            this.drawer.addEventListener(
                "theme:menu:toggle",
                function () {
                    this.drawer.classList.contains(ye) ? this.hideDrawer() : this.showDrawer();
                }.bind(this)
            );
        }
        staggerChildAnimations() {
            this.staggers.forEach((e) => {
                e.querySelectorAll(":scope > * > [data-animates]").forEach((e, t) => {
                    e.style.transitionDelay = 50 * t + 10 + "ms";
                });
            });
        }
        watchFocus(e) {
            this.drawer.contains(e.target) || this.hideDrawer();
        }
        closers() {
            this.drawer.addEventListener(
                "keyup",
                function (e) {
                    e.which === window.theme.keyboardKeys.ESCAPE && (this.hideDrawer(), this.buttons[0].focus());
                }.bind(this)
            ),
                this.underlay.addEventListener(
                    "click",
                    function () {
                        this.hideDrawer();
                    }.bind(this)
                );
        }
        showDrawer() {
            this.drawer.classList.remove(fe),
                setTimeout(() => {
                    this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
                        this.drawer.classList.add(ye),
                        this.drawer.querySelector(pe).focus(),
                        document.addEventListener("focusin", this.watchFocus.bind(this)),
                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                }, 1);
        }
        hideDrawer() {
            this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
                this.drawer.classList.remove(ye),
                document.removeEventListener("focusin", this.watchFocus),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                setTimeout(() => {
                    this.drawer.classList.contains(ye) || this.drawer.classList.add(fe);
                }, 1200);
        }
    }
    const we = {
        onLoad() {
            me[this.id] = [];
            this.container.querySelectorAll(ce).forEach((e) => {
                me[this.id].push(new ge(e));
            });
        },
        onUnload: function () {
            me[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    };
    var ve = "[data-popout]",
        be = "[data-popout-list]",
        Te = "[data-popout-toggle]",
        ke = "[data-popout-input]",
        Ee = "[data-popout-option]",
        Se = "popout-list--visible",
        _e = {};
    class Le {
        constructor(e) {
            (this.$container = e),
                (this.$popoutList = this.$container.find(be)),
                (this.$popoutToggle = this.$container.find(Te)),
                (this.$popoutInput = this.$container.find(ke)),
                (this.$popoutOptions = this.$container.find(Ee)),
                this._connectOptions(),
                this._connectToggle(),
                this._onFocusOut();
        }
        unload() {
            this.$popoutOptions.off(), this.$popoutToggle.off(), this.$popoutList.off(), this.$container.off();
        }
        _connectToggle() {
            this.$popoutToggle.on(
                "click",
                function (t) {
                    var i = "true" === e(t.currentTarget).attr("aria-expanded");
                    e(t.currentTarget).attr("aria-expanded", !i), this.$popoutList.toggleClass(Se);
                }.bind(this)
            );
        }
        _connectOptions() {
            this.$popoutOptions.on(
                "click",
                function (t) {
                    "#" === e(t.target).closest("[data-popout-option]")[0].attributes.href.value && (t.preventDefault(), this._submitForm(e(t.currentTarget).data("value")));
                }.bind(this)
            );
        }
        _onFocusOut() {
            this.$popoutToggle.on(
                "focusout",
                function (e) {
                    0 === this.$container.has(e.relatedTarget).length && this._hideList();
                }.bind(this)
            ),
                this.$popoutList.on(
                    "focusout",
                    function (t) {
                        var i = e(t.currentTarget).has(t.relatedTarget).length > 0;
                        this.$popoutList.hasClass(Se) && !i && this._hideList();
                    }.bind(this)
                ),
                this.$container.on(
                    "keyup",
                    function (e) {
                        e.which === window.theme.keyboardKeys.ESCAPE && (this._hideList(), this.$popoutToggle.focus());
                    }.bind(this)
                ),
                e("body").on(
                    "click",
                    function (e) {
                        var t = this.$container.has(e.target).length > 0;
                        this.$popoutList.hasClass(Se) && !t && this._hideList();
                    }.bind(this)
                );
        }
        _submitForm(e) {
            this.$popoutInput.val(e), this.$container.parents("form").submit();
        }
        _hideList() {
            this.$popoutList.removeClass(Se), this.$popoutToggle.attr("aria-expanded", !1);
        }
    }
    const Ae = {
            onLoad() {
                _e[this.id] = [];
                this.container.querySelectorAll(ve).forEach((t) => {
                    const i = e(t);
                    _e[this.id].push(new Le(i));
                });
            },
            onUnload: function () {
                _e[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        xe = {
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            children: ":scope > [data-animates], \n             :scope > * > [data-animates], \n             :scope > * > * >[data-animates],\n             :scope > .sliderule-grid  > *",
        },
        $e = "is-visible";
    let Ce = {};
    class qe {
        constructor(e) {
            (this.sliderule = e), (this.wrapper = e.closest(xe.wrapper)), (this.key = this.sliderule.id);
            const t = `[${xe.slideruleOpen}='${this.key}']`,
                i = `[${xe.slideruleClose}='${this.key}']`;
            (this.trigger = document.querySelector(t)),
                (this.exit = document.querySelector(i)),
                (this.pane = document.querySelector(`[${xe.sliderulePane}]`)),
                (this.children = this.sliderule.querySelectorAll(xe.children)),
                this.trigger.setAttribute("aria-haspopup", !0),
                this.trigger.setAttribute("aria-expanded", !1),
                this.trigger.setAttribute("aria-controls", this.key),
                this.clickEvents(),
                this.staggerChildAnimations();
        }
        clickEvents() {
            this.trigger.addEventListener(
                "click",
                function () {
                    this.showSliderule();
                }.bind(this)
            ),
                this.exit.addEventListener(
                    "click",
                    function () {
                        this.hideSliderule();
                    }.bind(this)
                );
        }
        keyboardEvents() {
            this.trigger.addEventListener(
                "keyup",
                function (e) {
                    e.which === window.theme.keyboardKeys.SPACE && this.showSliderule();
                }.bind(this)
            ),
                this.sliderule.addEventListener(
                    "keyup",
                    function (e) {
                        e.which === window.theme.keyboardKeys.ESCAPE && (this.hideSliderule(), this.buttons[0].focus());
                    }.bind(this)
                );
        }
        staggerChildAnimations() {
            this.children.forEach((e, t) => {
                e.style.transitionDelay = 50 * t + 10 + "ms";
            });
        }
        hideSliderule() {
            this.sliderule.classList.remove($e),
                this.children.forEach((e) => {
                    e.classList.remove($e);
                });
            const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
            this.pane.setAttribute(xe.sliderulePane, e);
        }
        showSliderule() {
            this.sliderule.classList.add($e),
                this.children.forEach((e) => {
                    e.classList.add($e);
                });
            const e = parseInt(this.pane.dataset.sliderulePane, 10) + 1;
            this.pane.setAttribute(xe.sliderulePane, e);
        }
    }
    const Pe = {
            onLoad() {
                Ce[this.id] = [];
                this.container.querySelectorAll(xe.slideruleWrappper).forEach((e) => {
                    Ce[this.id].push(new qe(e));
                });
            },
            onUnload: function () {
                Ce[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        je = "[data-announcement-wrapper]",
        De = "data-header-transparent",
        Oe = "[data-header-wrapper] header",
        Ie = "js__header__stuck",
        He = "js__header__stuck--animated",
        Fe = "js__header__stuck--trigger-animation",
        Be = "js__header__stuck__backdrop";
    let ze = {};
    class Me {
        constructor(e) {
            (this.wrapper = e),
                (this.type = this.wrapper.dataset.headerSticky),
                (this.transparent = this.wrapper.dataset.headerTransparent),
                (this.sticks = "sticky" === this.type),
                (this.animated = "directional" === this.type),
                (this.currentlyStuck = !1),
                (this.cls = this.wrapper.classList);
            const t = document.querySelector(je),
                i = t ? t.clientHeight : 0,
                o = document.querySelector(Oe).clientHeight;
            (this.blur = o + i), (this.stickDown = o + i), (this.stickUp = i), "false" !== this.wrapper.getAttribute(De) && (this.blur = i), this.sticks && ((this.stickDown = i), this.scrollDownInit()), this.listen();
        }
        unload() {
            document.removeEventListener("theme:scroll", this.listen), document.removeEventListener("theme:scroll:up", this.scrollUpDirectional), document.removeEventListener("theme:scroll:down", this.scrollDownDirectional);
        }
        listen() {
            (this.sticks || this.animated) &&
                document.addEventListener("theme:scroll", (e) => {
                    e.detail.down
                        ? (!this.currentlyStuck && e.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && e.detail.position > this.blur && this.addBlur())
                        : (e.detail.position <= this.stickUp && this.unstickSimple(), e.detail.position <= this.blur && this.removeBlur());
                }),
                this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)), document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)));
        }
        stickSimple() {
            this.animated && this.cls.add(He), this.cls.add(Ie), this.wrapper.setAttribute(De, !1), (this.currentlyStuck = !0);
        }
        unstickSimple() {
            this.cls.remove(Ie), this.wrapper.setAttribute(De, this.transparent), this.animated && this.cls.remove(He), (this.currentlyStuck = !1);
        }
        scrollDownInit() {
            window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur();
        }
        stickDirectional() {
            this.cls.add(Fe);
        }
        unstickDirectional() {
            this.cls.remove(Fe);
        }
        scrollDownDirectional() {
            this.unstickDirectional();
        }
        scrollUpDirectional() {
            window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional();
        }
        addBlur() {
            this.cls.add(Be), (this.currentlyBlurred = !0);
        }
        removeBlur() {
            this.cls.remove(Be), (this.currentlyBlurred = !1);
        }
    }
    const Ue = {
            onLoad() {
                ze = new Me(this.container);
            },
            onUnload: function () {
                "function" == typeof ze.unload && ze.unload();
            },
        },
        Ve = "data-hover-disclosure-toggle",
        We = "[data-hover-disclosure]",
        Re = "[data-top-link]",
        Ne = "meganav--visible",
        Ke = "[data-header-wrapper]",
        Ye = "[data-stagger]",
        Je = "[data-stagger-first]",
        Qe = "[data-stagger-second]",
        Ge = "[data-grid-item], [data-header-image]",
        Xe = "is-visible";
    let Ze = {},
        et = {};
    class tt {
        constructor(e) {
            (this.disclosure = e), (this.wrapper = e.closest(Ke)), (this.key = this.disclosure.id);
            const t = `[${Ve}='${this.key}']`;
            (this.trigger = document.querySelector(t)),
                (this.link = this.trigger.querySelector(Re)),
                (this.grandparent = this.trigger.classList.contains("grandparent")),
                this.trigger.setAttribute("aria-haspopup", !0),
                this.trigger.setAttribute("aria-expanded", !1),
                this.trigger.setAttribute("aria-controls", this.key),
                this.connectHoverToggle(),
                this.handleTablets(),
                this.staggerChildAnimations();
        }
        onBlockSelect(e) {
            this.disclosure.contains(e.target) && this.showDisclosure();
        }
        onBlockDeselect(e) {
            this.disclosure.contains(e.target) && this.hideDisclosure();
        }
        showDisclosure() {
            this.grandparent ? this.wrapper.classList.add(Ne) : this.wrapper.classList.remove(Ne), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(Xe), this.disclosure.classList.add(Xe);
        }
        hideDisclosure() {
            this.disclosure.classList.remove(Xe), this.trigger.classList.remove(Xe), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(Ne);
        }
        staggerChildAnimations() {
            this.disclosure.querySelectorAll(Ye).forEach((e, t) => {
                e.style.transitionDelay = 50 * t + 10 + "ms";
            });
            this.disclosure.querySelectorAll(Je).forEach((e, t) => {
                const i = 150 * t;
                (e.style.transitionDelay = i + "ms"),
                    e.parentElement.querySelectorAll(Qe).forEach((e, t) => {
                        const o = 20 * (t + 1);
                        e.style.transitionDelay = i + o + "ms";
                    });
            });
            this.disclosure.querySelectorAll(Ge).forEach((e, t) => {
                e.style.transitionDelay = 80 * (t + 1) + "ms";
            });
        }
        handleTablets() {
            this.trigger.addEventListener(
                "touchstart",
                function (e) {
                    this.disclosure.classList.contains(Xe) || (e.preventDefault(), this.showDisclosure());
                }.bind(this),
                { passive: !0 }
            );
        }
        connectHoverToggle() {
            this.trigger.addEventListener("mouseenter", this.showDisclosure.bind(this)),
                this.link.addEventListener("focus", this.showDisclosure.bind(this)),
                this.trigger.addEventListener("mouseleave", this.hideDisclosure.bind(this)),
                this.trigger.addEventListener(
                    "focusout",
                    function (e) {
                        this.trigger.contains(e.relatedTarget) || this.hideDisclosure();
                    }.bind(this)
                ),
                this.disclosure.addEventListener(
                    "keyup",
                    function (e) {
                        e.which === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                    }.bind(this)
                );
        }
    }
    const it = {
            onLoad() {
                (Ze[this.id] = []),
                    (et = this.container.querySelectorAll(We)),
                    et.forEach((e) => {
                        Ze[this.id].push(new tt(e));
                    });
            },
            onBlockSelect(e) {
                Ze[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                Ze[this.id].forEach((t) => {
                    "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                });
            },
            onUnload: function () {
                Ze[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        ot = "[data-main-menu-text-item]",
        nt = "[data-text-items-wrapper]",
        st = ".navtext",
        rt = "data-menu-active",
        at = "[data-header-wrapper]";
    let lt = {};
    class ct {
        constructor(e) {
            if (((this.wrapper = e), (this.itemList = this.wrapper.querySelectorAll(ot)), (this.sectionOuter = document.querySelector(at)), this.itemList.length)) {
                this.listen(), (this.textBottom = null), this.setHeight();
                const e = this.sectionOuter.querySelector(ot).offsetLeft;
                this.sectionOuter.style.setProperty("--bar-left", e + "px"), this.sectionOuter.style.setProperty("--bar-width", "0px");
            }
        }
        setHeight() {
            const e = this.wrapper.clientHeight,
                t = this.itemList[0].querySelector(st).clientHeight,
                i = Math.floor(e / 2 - t / 2) - 4;
            this.textBottom !== i && (this.sectionOuter.style.setProperty("--bar-bottom", i + "px"), (this.textBottom = i));
        }
        listen() {
            this.itemList.forEach((e) => {
                e.addEventListener("mouseenter", (e) => {
                    const t = e.target.querySelector(st);
                    this.startBar(t);
                });
            }),
                this.wrapper.addEventListener("mouseleave", this.clearBar.bind(this));
        }
        startBar(e) {
            this.setHeight();
            let t = "false" !== this.sectionOuter.getAttribute(rt),
                i = e.offsetLeft,
                o = e.clientWidth;
            t
                ? this.render(o, i)
                : (this.sectionOuter.setAttribute(rt, !0),
                  this.render(0, i),
                  setTimeout(() => {
                      this.render(o, i);
                  }, 10));
        }
        render(e, t) {
            this.sectionOuter.style.setProperty("--bar-left", t + "px"), this.sectionOuter.style.setProperty("--bar-width", e + "px");
        }
        clearBar() {
            this.sectionOuter.setAttribute(rt, !1),
                setTimeout(() => {
                    "false" !== this.sectionOuter.getAttribute(rt) || this.sectionOuter.style.setProperty("--bar-width", "0px");
                }, 350);
        }
    }
    const dt = {
            onLoad() {
                lt[this.id] = [];
                this.container.querySelectorAll(nt).forEach((e) => {
                    lt[this.id].push(new ct(e));
                });
            },
            onUnload: function () {
                lt[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        ht = "data-header-cart-price",
        ut = "data-header-cart-count",
        pt = "data-header-cart-full";
    class yt {
        constructor(e) {
            (this.section = e), (this.counts = this.section.querySelectorAll(`[${ut}]`)), (this.prices = this.section.querySelectorAll(`[${ht}]`)), (this.dots = this.section.querySelectorAll(`[${pt}]`)), (this.cart = null), this.listen();
        }
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (e) {
                    (this.cart = e.detail.cart), this.update();
                }.bind(this)
            );
        }
        update() {
            console.log(this.cart),
                this.cart &&
                    (this.prices.forEach((e) => {
                        e.setAttribute(ht, this.cart.total_price);
                        const t = o.formatMoney(this.cart.total_price, theme.moneyFormat);
                        e.innerHTML = t;
                    }),
                    this.counts.forEach((e) => {
                        e.setAttribute(ut, this.cart.item_count), (e.innerHTML = `(${this.cart.item_count})`);
                    }),
                    this.dots.forEach((e) => {
                        const t = this.cart.item_count > 0;
                        e.setAttribute(pt, t);
                    }));
        }
    }
    const ft = {
        onLoad() {
            new yt(this.container);
        },
    };
    function mt(e) {
        return P({ json: window.theme.assets.swatches })
            .then((t) =>
                (function (e, t) {
                    let i = "#E5E5E5",
                        o = null;
                    const n = window.theme.assets.base || "/",
                        s = t.toLowerCase().replace(/\s/g, ""),
                        r = e.colors;
                    if (r) {
                        const e = (e) => Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === s,
                            t = r.findIndex(e);
                        if (t > -1) {
                            const e = Object.values(r[t])[0];
                            e.includes(".jpg") || e.includes(".jpeg") || e.includes(".png") || e.includes(".svg") ? ((o = `${n}${e}`), (i = "#888888")) : (i = e);
                        }
                    }
                    return { path: o, hex: i };
                })(t, e)
            )
            .catch((e) => {
                console.log("failed to load swatch colors script"), console.log(e);
            });
    }
    async function gt(e) {
        var t,
            i,
            o,
            n,
            s = e.getAttribute("data-swatch-handle"),
            r = e.getAttribute("data-swatch-label").trim().toLowerCase(),
            a = await (function (e) {
                let t = window.theme.routes.root_url || "";
                "/" !== t[t.length - 1] && (t += "/");
                const i = `${t}products/${e}.js` || "/recommendations/products/";
                return window
                    .fetch(i)
                    .then((e) => e.json())
                    .catch((e) => {
                        console.error(e);
                    });
            })(s),
            l = a.options.find(function (e) {
                return e.name.toLowerCase() === r || null;
            });
        if (l) {
            var c = l.values,
                d = document.createElement("fieldset");
            d.setAttribute("class", "radio__fieldset radio__fieldset--swatch"), e.appendChild(d);
            for (var h = 0; h < c.length; h++) {
                var u = c[h],
                    p = await mt(u),
                    y = p.hex;
                let e = "";
                p.path && (e = ` background-image: url('${p.path}'); background-size: cover;`);
                var f = "",
                    m = a.variants.find((e) => e.options.includes(u) && e.featured_media);
                void 0 === m ? (m = a.variants.find((e) => e.options.includes(u))) : (f = m.featured_media.preview_image.src);
                var g = "" + m.id,
                    w = `swatch-${m.id}-${((t = 1), (i = 500), (o = void 0), (n = void 0), (o = Math.ceil(t)), (n = Math.floor(i)), Math.floor(Math.random() * (n - o + 1)) + o)}`,
                    v = `<span class="swatch__button" data-swatch-button data-variant="${g}" data-image="${f}">\n        <input type="radio" name="options[${r}]" value="${u}" id="${w}">\n        <label for="${w}" style="--swatch: ${y}; ${e}">\n          <span class="visually-hidden">${u}</span>\n        </label>\n      </span>`;
                d.innerHTML += v;
            }
        }
        return Promise.resolve();
    }
    function wt(t) {
        var i = e(t);
        e("[data-swatch-button]", i)
            .off()
            .click(function () {
                var t = e(this),
                    i = t.attr("data-variant"),
                    o = t.attr("data-image");
                t.closest("[data-grid-item]")
                    .find("[data-grid-link]")
                    .attr("href", function (e, t) {
                        return s.getUrlWithVariant(t, i);
                    });
                var r,
                    a = t.closest("[data-grid-item]").find("[data-grid-slide]");
                if (o) {
                    var l = ((r = a[0].offsetWidth), 180 * Math.ceil(r / 180)),
                        c = n.getSizedImageUrl(o, l + "x");
                    window
                        .fetch(c)
                        .then((e) => e.blob())
                        .then((e) => {
                            var t = URL.createObjectURL(e);
                            return a.css("background-color", "#fff"), a.css("background-image", `url("${t}")`), t;
                        })
                        .catch((e) => {
                            console.log("Error: " + e);
                        });
                }
            });
    }
    const vt = {
            onLoad() {
                this.container.querySelectorAll("[data-grid-swatches]").forEach((e) => {
                    gt(e).then(() => {
                        wt(e);
                    });
                });
            },
        },
        bt = "[data-takes-space]",
        Tt = "[data-header-desktop]",
        kt = "js__header__clone",
        Et = "js__show__mobile",
        St = "[data-header-backfill]",
        _t = "data-header-transparent",
        Lt = "header-override-border",
        At = ".main-content > .shopify-section:first-child [data-overlay-header]",
        xt = '.navlink[href="#"]';
    let $t = {};
    class Ct {
        constructor(e) {
            (this.wrapper = e),
                (this.style = this.wrapper.dataset.style),
                (this.desktop = this.wrapper.querySelector(Tt)),
                (this.transparent = "false" !== this.wrapper.getAttribute(_t)),
                (this.overlayedImages = document.querySelectorAll(At)),
                (this.deadLinks = document.querySelectorAll(xt)),
                this.killDeadLinks(),
                "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                this.checkForImage();
        }
        unload() {
            document.removeEventListener("theme:resize", this.checkWidth);
        }
        checkForImage() {
            this.overlayedImages.length > 0 && this.transparent ? ((document.querySelector(St).style.display = "none"), this.listenOverlay()) : this.wrapper.setAttribute(_t, !1),
                this.overlayedImages.length > 0 && !this.transparent && (this.wrapper.classList.add(Lt), this.subtractHeaderHeight());
        }
        listenOverlay() {
            document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.subtractAnnouncementHeight();
        }
        listenWidth() {
            document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth();
        }
        killDeadLinks() {
            this.deadLinks.forEach((e) => {
                e.onclick = (e) => {
                    e.preventDefault();
                };
            });
        }
        subtractAnnouncementHeight() {
            const { windowHeight: e, announcementHeight: t } = m();
            this.overlayedImages.forEach((i) => {
                i.style.setProperty("--full-screen", e - t + "px"), i.classList.add("has-overlay");
            });
        }
        subtractHeaderHeight() {
            const { windowHeight: e, headerHeight: t } = m();
            this.overlayedImages.forEach((i) => {
                i.style.setProperty("--full-screen", e - t + "px");
            });
        }
        checkWidth() {
            document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(Et) : this.wrapper.classList.remove(Et);
        }
        getMinWidth() {
            const e = this.wrapper.cloneNode(!0);
            e.classList.add(kt), document.body.appendChild(e);
            const t = e.querySelectorAll(bt);
            let i = 0;
            return (
                (i =
                    3 === t.length
                        ? (function (e) {
                              let t = [];
                              e.forEach((e) => {
                                  t.push(e.clientWidth);
                              }),
                                  t[0] > t[2] ? (t[2] = t[0]) : (t[0] = t[2]);
                              return t.reduce((e, t) => e + t);
                          })(t)
                        : (function (e) {
                              let t = 0;
                              return (
                                  e.forEach((e) => {
                                      t += e.clientWidth;
                                  }),
                                  t
                              );
                          })(t)),
                document.body.removeChild(e),
                i + 20 * t.length
            );
        }
    }
    B("header", [
        {
            onLoad() {
                $t = new Ct(this.container);
            },
            onUnload: function () {
                "function" == typeof $t.unload && $t.unload();
            },
        },
        we,
        Ae,
        Pe,
        Ue,
        it,
        dt,
        ft,
        Z,
        vt,
    ]);
    B("footer", [
        Ae,
        {
            onLoad() {
                var e = document.querySelector("[data-powered-link] a");
                e && e.relList.add("noopener");
            },
        },
    ]);
    var qt = !1;
    function Pt() {
        return qt;
    }
    document.addEventListener(
        "touchstart",
        function e() {
            (qt = !0), document.removeEventListener("touchstart", e, { passive: !0 }), document.querySelector("body").classList.add("supports-touch"), document.dispatchEvent(new CustomEvent("theme:touch", { bubbles: !0 }));
        },
        { passive: !0 }
    );
    const jt = { cc_load_policy: 1, iv_load_policy: 3, modestbranding: 1, playsinline: 1, controls: 1, showinfo: 0, ecver: 2, fs: 1, rel: 0 };
    function Dt(t, i) {
        const o = { ...jt, ...i },
            n = e(`[data-player="${t}"]`),
            s = n.find("iframe, [data-replace]"),
            r = n.find("[data-video-id]").attr("data-video-id");
        P({ url: "https://www.youtube.com/iframe_api" });
        return window.youtubeLoaderPromise
            .then(function () {
                let e = new window.YT.Player(s[0], { videoId: r, playerVars: { ...o } });
                return (
                    n.on("pause", function () {
                        try {
                            e.pauseVideo && e.pauseVideo();
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    n.on("play-desktop", function () {
                        Pt() || n.trigger("play");
                    }),
                    n.on("play", function () {
                        try {
                            e.playVideo
                                ? e.playVideo()
                                : e.addEventListener("onReady", function (e) {
                                      e.target.playVideo();
                                  });
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    n.on("destroy", function () {
                        try {
                            e.destroy && e.destroy();
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    e
                );
            })
            .catch(function (e) {
                console.error(e);
            });
    }
    window.youtubeLoaderPromise = new Promise((e) => {
        window.onYouTubeIframeAPIReady = function () {
            e();
        };
    });
    const Ot = { autoplay: !0, loop: !0, controls: !0, muted: !1, playsinline: !0 };
    function It(t, i) {
        const o = { ...Ot, ...i },
            n = e(`[data-player="${t}"]`),
            s = n.find("iframe, [data-replace]"),
            r = n.find("[data-video-id]").attr("data-video-id"),
            a = P({ url: "https://player.vimeo.com/api/player.js" }),
            l = "select-" + t;
        s.attr("id", l);
        return a
            .then(function () {
                const e = new window.Vimeo.Player(l, { ...o, id: r });
                return (
                    n.on("pause", function () {
                        try {
                            e.pause && e.pause();
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    n.on("play-desktop", function () {
                        Pt() || n.trigger("play");
                    }),
                    n.on("play", function () {
                        e.play && e.play();
                    }),
                    n.on("destroy", function () {
                        try {
                            e.destroy && e.destroy();
                        } catch (e) {
                            console.log(e);
                        }
                    }),
                    e
                );
            })
            .catch(function (e) {
                console.error(e);
            });
    }
    function Ht(i) {
        const o = e(i).find("[data-video-popup]"),
            n = e(i).find("[data-video-autoplay]");
        e.each(o, function (i, o) {
            const s = e(o),
                r = s.attr("data-unique"),
                a = s.attr("data-video-id"),
                l = s.attr("data-video-type"),
                c = `${a}-${r}`,
                d = e(document).find(`[data-player="${c}"]`);
            t.init({
                onShow: () => {
                    n.trigger("pause");
                    let e = {};
                    "youtube" === l ? (e = Dt(c)) : "vimeo" === l && (e = It(c)),
                        e.then(() => {
                            d.trigger("play");
                        });
                },
                onClose: () => {
                    d.trigger("destroy"), n.trigger("play");
                },
                openTrigger: `data-trigger-${a}-${r}`,
            });
        });
    }
    const Ft = "[data-scroll-down]";
    class Bt {
        constructor(e) {
            (this.wrapper = e), this.init();
        }
        init() {
            const e = this.wrapper.querySelectorAll(Ft);
            e &&
                e.forEach((e) => {
                    e.addEventListener("click", this.scroll.bind(this));
                });
        }
        scroll() {
            const e = this.wrapper.offsetTop + this.wrapper.clientHeight;
            window.scroll({ top: e, left: 0, behavior: "smooth" });
        }
    }
    const zt = {
        onLoad() {
            this.scrollButton = new Bt(this.container);
        },
        onUnload: function () {
            delete this.scrollButton;
        },
    };
    var Mt = "[data-video-autoplay]",
        Ut = "[data-player]";
    const Vt = { autoplay: !1, loop: !0, controls: !1, muted: !0, playsinline: !0 },
        Wt = { autoplay: 1, cc_load_policy: 0, iv_load_policy: 0, modestbranding: 1, playsinline: 1, fs: 0, controls: 0 };
    B("video", [
        {
            onLoad() {
                !(function (t) {
                    const i = t.querySelectorAll(Mt);
                    if (i.length) {
                        var o = i[0].dataset.videoType;
                        const t = i[0].dataset.player;
                        if ("vimeo" == o) {
                            It(t, Vt)
                                .then((t) => {
                                    return (
                                        (i = t)
                                            .play()
                                            .then(() => {
                                                e(i.element).closest("[data-video-autoplay]").css("opacity", "1");
                                            })
                                            .catch((e) => {
                                                console.log(e);
                                            }),
                                        i.setLoop(!0),
                                        i
                                    );
                                    var i;
                                })
                                .catch((e) => {
                                    console.error(e);
                                });
                        } else if ("youtube" == o) {
                            Dt(t, Wt)
                                .then((t) =>
                                    (function (t) {
                                        return (
                                            t.addEventListener("onReady", function (e) {
                                                e.target.mute(), e.target.playVideo();
                                            }),
                                            t.addEventListener("onStateChange", function (t) {
                                                switch (t.data) {
                                                    case -1:
                                                        t.target.mute();
                                                        break;
                                                    case 0:
                                                        t.target.playVideo();
                                                        break;
                                                    case 1:
                                                        e(t.target.getIframe()).closest("[data-video-autoplay]").css("opacity", "1");
                                                }
                                            }),
                                            t
                                        );
                                    })(t)
                                )
                                .catch((e) => {
                                    console.error(e);
                                });
                        }
                    }
                })(this.container),
                    Ht(this.container, this.id);
            },
            onUnload() {
                e(Ut, this.container).trigger("destroy");
            },
        },
        N,
        zt,
    ]);
    const Rt = "[data-page-image-title]",
        Nt = "has-no-title";
    class Kt {
        constructor(e) {
            (this.container = e), (this.imageTitle = this.container.querySelector(Rt)), this.imageTitle || this.container.parentElement.classList.add(Nt);
        }
    }
    B("page", [
        {
            onLoad() {
                new Kt(this.container);
            },
        },
        N,
    ]);
    const Yt = { accordionToggle: "data-accordion-toggle", accordionWrappper: "[data-accordion]", block: "data-accordion-block", focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' },
        Jt = "is-visible";
    let Qt = {};
    class Gt {
        constructor(e) {
            (this.accordion = e), (this.wrapper = e.closest(Yt.wrapper)), (this.key = this.accordion.id);
            const t = `[${Yt.accordionToggle}='${this.key}']`;
            (this.trigger = document.querySelector(t)),
                (this.children = this.accordion.querySelectorAll(":scope > *")),
                this.trigger.setAttribute("aria-haspopup", !0),
                this.trigger.setAttribute("aria-expanded", !1),
                this.trigger.setAttribute("aria-controls", this.key),
                this.clickEvents(),
                this.staggerChildAnimations();
        }
        clickEvents() {
            this.trigger.addEventListener(
                "click",
                function () {
                    this.toggleState();
                }.bind(this)
            );
        }
        keyboardEvents() {
            this.trigger.addEventListener(
                "keyup",
                function (e) {
                    e.which === window.theme.keyboardKeys.SPACE && this.showAccordion();
                }.bind(this)
            ),
                this.accordion.addEventListener(
                    "keyup",
                    function (e) {
                        e.which === window.theme.keyboardKeys.ESCAPE && (this.hideAccordion(), this.buttons[0].focus());
                    }.bind(this)
                );
        }
        staggerChildAnimations() {
            this.children.forEach((e, t) => {
                e.style.transitionDelay = 80 * t + 10 + "ms";
            });
        }
        toggleState() {
            this.accordion.classList.contains(Jt) ? this.hideAccordion() : this.showAccordion();
        }
        hideAccordion() {
            this.accordion.classList.remove(Jt), this.trigger.classList.remove(Jt);
        }
        showAccordion() {
            this.accordion.classList.add(Jt), this.trigger.classList.add(Jt);
        }
        onBlockSelect(e) {
            console.log(e), this.accordion.contains(e.target) && this.showAccordion();
        }
        onBlockDeselect(e) {
            this.accordion.contains(e.target) && this.hideAccordion();
        }
    }
    B("page-faq", {
        onLoad() {
            Qt[this.id] = [];
            this.container.querySelectorAll(Yt.accordionWrappper).forEach((e) => {
                Qt[this.id].push(new Gt(e));
            });
        },
        onUnload: function () {
            Qt[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
        onBlockSelect(e) {
            Qt[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
        onBlockDeselect(e) {
            Qt[this.id].forEach((t) => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
            });
        },
    }),
        B("hero", [N, zt]),
        B("double", N);
    B("slideshow", [
        {
            onLoad() {
                let t = "#slideshow-" + this.id;
                const i = e(t),
                    o = e(this.container);
                i.slick({ autoplay: i.data("autoplay"), autoplaySpeed: i.data("speed"), prevArrow: o.find("[data-prev-arrow]"), nextArrow: o.find("[data-next-arrow]"), adaptiveHeight: !1, dots: !1 });
            },
            onUnload() {},
            onBlockSelect(t) {
                let i = e("#slideshow-" + this.id),
                    o = e(".slideshow__slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                i.slick("slickGoTo", o).slick("slickPause");
            },
        },
        N,
        zt,
    ]);
    const Xt = "data-padding",
        Zt = "isActive",
        ei = "gallery--disabled",
        ti = "[data-section-type]",
        ii = "[data-gallery-enabled]";
    class oi {
        constructor(e) {
            (this.section = e), (this.outer = this.section.parentNode), (this.inner = this.section.querySelector(ii)), this.inner && this.outer.classList.add(Zt), this.findNext(this.outer);
        }
        findNext(e) {
            const t = e.nextElementSibling;
            if (null === t) return;
            null === t.querySelector(ii) ? (t.classList.add(ei), this.findNext(t)) : ((this.nextOuter = t), this.subtractPadding());
        }
        subtractPadding() {
            if (((this.padded = "false" !== this.section.getAttribute(Xt)), (this.nextPadded = "false" !== this.nextOuter.querySelector(ti).getAttribute(Xt)), this.padded && this.nextPadded)) {
                const e = this.nextOuter.querySelector(ii);
                e && e.style.setProperty("padding-top", "0px");
            }
        }
    }
    const ni = {
        onLoad() {
            new oi(this.container);
        },
    };
    function si() {
        this.entries = [];
    }
    function ri(e, t) {
        return (
            ai(e),
            (function (e, t) {
                return (
                    ai(e),
                    (function (e) {
                        if (Array.isArray(e) && "object" == typeof e[0]) throw new Error(e + "is not a valid array of options.");
                    })(t),
                    e.variants.filter(function (e) {
                        return t.every(function (t, i) {
                            return e.options[i] === t;
                        });
                    })[0] || null
                );
            })(
                e,
                (function (e, t) {
                    ai(e),
                        (function (e) {
                            if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
                            if (0 === e.length) throw new Error(e + " is empty.");
                            if (!e[0].hasOwnProperty("name")) throw new Error(e[0] + "does not contain name key.");
                            if ("string" != typeof e[0].name) throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.");
                        })(t);
                    var i = [];
                    return (
                        t.forEach(function (t) {
                            for (var o = 0; o < e.options.length; o++) {
                                if ((e.options[o].name || e.options[o]).toLowerCase() === t.name.toLowerCase()) {
                                    i[o] = t.value;
                                    break;
                                }
                            }
                        }),
                        i
                    );
                })(e, t)
            )
        );
    }
    function ai(e) {
        if ("object" != typeof e) throw new TypeError(e + " is not an object.");
        if (0 === Object.keys(e).length && e.constructor === Object) throw new Error(e + " is empty.");
    }
    B("gallery", [
        ni,
        {
            onLoad() {
                Ht(this.container),
                    (function (i) {
                        const o = e(i).find("[data-image-zoom]");
                        e.each(o, function (i, o) {
                            const n = e(o).attr("data-unique");
                            t.init({
                                disableScroll: !0,
                                openTrigger: "data-popup-" + n,
                                onShow: (t) => {
                                    e("[data-src]", t).each(function () {
                                        var t = e(this);
                                        void 0 === t.attr("src") && t.attr("src", t.attr("data-src"));
                                    });
                                },
                            });
                        });
                    })(this.container);
            },
        },
    ]),
        B("gallery-text", ni),
        (si.prototype.add = function (e, t, i) {
            this.entries.push({ element: e, event: t, fn: i }), e.addEventListener(t, i);
        }),
        (si.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (e) {
                return e.element.removeEventListener(e.event, e.fn), !1;
            });
        });
    var li = '[name="id"]',
        ci = '[name^="options"]',
        di = '[name="quantity"]',
        hi = '[name^="properties"]';
    function ui(e, t, i) {
        (this.element = e),
            (this.product = (function (e) {
                if ("object" != typeof e) throw new TypeError(e + " is not an object.");
                if (void 0 === e.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                return e;
            })(t)),
            (i = i || {}),
            (this._listeners = new si()),
            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
            (this.optionInputs = this._initInputs(ci, i.onOptionChange)),
            (this.quantityInputs = this._initInputs(di, i.onQuantityChange)),
            (this.propertyInputs = this._initInputs(hi, i.onPropertyChange));
    }
    function pi(e, t) {
        return e.reduce(function (e, i) {
            return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && e.push(t({ name: i.name, value: i.value })), e;
        }, []);
    }
    (ui.prototype.destroy = function () {
        this._listeners.removeAll();
    }),
        (ui.prototype.options = function () {
            return pi(this.optionInputs, function (e) {
                return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
            });
        }),
        (ui.prototype.variant = function () {
            return ri(this.product, this.options());
        }),
        (ui.prototype.properties = function () {
            return pi(this.propertyInputs, function (e) {
                return (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e;
            });
        }),
        (ui.prototype.quantity = function () {
            return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
        }),
        (ui.prototype._setIdInputValue = function (e) {
            var t = this.element.querySelector(li);
            t || (((t = document.createElement("input")).type = "hidden"), (t.name = "id"), this.element.appendChild(t)), (t.value = e.toString());
        }),
        (ui.prototype._onSubmit = function (e, t) {
            (t.dataset = this._getProductFormEventData()), this._setIdInputValue(t.dataset.variant.id), e.onFormSubmit && e.onFormSubmit(t);
        }),
        (ui.prototype._onFormEvent = function (e) {
            return void 0 === e
                ? Function.prototype
                : function (t) {
                      (t.dataset = this._getProductFormEventData()), e(t);
                  }.bind(this);
        }),
        (ui.prototype._initInputs = function (e, t) {
            return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
                function (e) {
                    return this._listeners.add(e, "change", this._onFormEvent(t)), e;
                }.bind(this)
            );
        }),
        (ui.prototype._getProductFormEventData = function () {
            return { options: this.options(), variant: this.variant(), properties: this.properties(), quantity: this.quantity() };
        });
    const yi = "[data-product-add-popdown-template]";
    var fi,
        mi = e("[data-product-add-popdown-wrapper]"),
        gi = e(yi).html(),
        wi = {};
    var vi = function () {
        window
            .fetch("/cart.js")
            .then(bi)
            .then((e) => e.json())
            .then((e) => {
                document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: e }, bubbles: !0 }));
            })
            .catch((e) => {
                console.error(e);
            });
    };
    function bi(e) {
        return e.ok
            ? e
            : e.json().then(function (t) {
                  throw new Ti({ status: e.statusText, headers: e.headers, json: t });
              });
    }
    function Ti(e) {
        (this.status = e.status || null), (this.headers = e.headers || null), (this.json = e.json || null), (this.body = e.body || null);
    }
    Ti.prototype = Error.prototype;
    var ki = function (e) {
            var t = '<div class="errors">' + e.responseJSON.description + "</div>";
            mi.empty(), mi.append(t), mi.addClass("has-errors is-visible"), Si();
        },
        Ei = function (t) {
            var i = n.getSizedImageUrl(t.image, "360x360"),
                s = { product_title: t.product_title, product_image: i, quantity: t.quantity, price: o.formatMoney(t.price, theme.moneyFormat) };
            mi.empty(), (wi = l.render(gi, s)), mi.append(wi);
            var r = e("[data-header-wrapper").outerHeight() + e("[data-announcement-wrapper]").outerHeight();
            mi.attr("style", ""), mi.css("min-height", r), mi.addClass("is-visible"), Si();
        },
        Si = function () {
            clearTimeout(fi),
                (fi = setTimeout(() => {
                    mi.removeClass("is-visible").removeClass("has-errors");
                }, 5e3));
        };
    function _i(t) {
        !(function (t) {
            e(".tab-content-0", t).addClass("current"),
                e(".tab-link-0", t).addClass("current"),
                e("ul.tabs > li", t).click(function () {
                    var i = e(this).attr("data-tab");
                    e("ul.tabs > li", t).removeClass("current"), e(".tab-content", t).removeClass("current"), e(this).addClass("current"), e(".tab-content-" + i, t).addClass("current");
                });
        })(t),
            (function (t) {
                e(".accordion-toggle", t).click(function () {
                    e(this).next("div").is(":visible") ? (e(this).next("div").slideUp("fast"), e(this).removeClass("accordionExpanded")) : (e(this).next("div").slideDown("fast"), e(this).addClass("accordionExpanded"));
                });
            })(t),
            Li(t),
            e(window).on(
                "resize",
                E(function () {
                    Li(t);
                }, 200)
            );
    }
    function Li(t) {
        var i = 0;
        e(".tab-link").each(function () {
            i += parseInt(e(this).width(), 10);
        });
        var o = e(".productTabsWrapper", t).width() - 10;
        i >= o ? (e(".product-tabs", t).css({ position: "absolute", left: "-9999px", display: "table" }), e(".product-accordion", t).show()) : (e(".product-tabs", t).removeAttr("style"), e(".product-accordion", t).hide());
    }
    mi.on("click", "[data-close-popdown]", () => {
        mi.removeClass("is-visible").removeClass("has-errors");
    });
    var Ai = {},
        xi = {};
    function $i(t) {
        if (t) console.warn(t);
        else if (window.ShopifyXR) {
            for (var i in Ai)
                if (Ai.hasOwnProperty(i)) {
                    var o = Ai[i];
                    if (o.loaded) continue;
                    var n = e("#ModelJson-" + i);
                    n.length && (window.ShopifyXR.addModels(JSON.parse(n.html())), (o.loaded = !0));
                }
            window.ShopifyXR.setupXRElements();
        } else
            document.addEventListener("shopify_xr_initialized", function () {
                $i();
            });
    }
    function Ci(e) {
        if (e) console.warn(e);
        else
            for (var t in xi)
                if (xi.hasOwnProperty(t)) {
                    var i = xi[t];
                    i.modelViewerUi || (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element[0])), qi(i);
                }
    }
    function qi(e) {
        e.$container
            .on("pause", function () {
                e.modelViewerUi.pause && e.modelViewerUi.pause();
            })
            .on("play-desktop", function () {
                e.modelViewerUi.play && !Pt() && e.modelViewerUi.play();
            })
            .on("play", function () {
                e.modelViewerUi.play && e.modelViewerUi.play();
            });
    }
    async function Pi(t) {
        const i = e(`[data-player="${t}"]`),
            o = i.find("video");
        await P({ name: "video-ui", version: "1.0" });
        const n = new window.Shopify.Plyr(o[0]);
        return (
            i.on("pause", function () {
                n.pause && n.pause();
            }),
            i.on("play-desktop", function () {
                n.play && !Pt() && i.trigger("play");
            }),
            i.on("play", function () {
                try {
                    n.play
                        ? n.play()
                        : n.addEventListener("onReady", function (e) {
                              e.target.play();
                          });
                } catch (e) {
                    console.warn(e);
                }
            }),
            i.on("destroy", function () {
                try {
                    n.destroy && n.destroy();
                } catch (e) {
                    console.warn(e);
                }
            }),
            n
        );
    }
    var ji = {
            productSlideshow: "[data-product-slideshow]",
            productThumbs: "[data-product-thumbs]",
            productImage: "[data-product-image]",
            mediaSlide: "[data-media-slide]",
            videoPlayerExternal: '[data-type="external_video"]',
            videoPlayerNative: '[data-type="video"]',
            modelViewer: '[data-type="model"]',
            allPlayers: "[data-player]",
            xrButton: "[data-shopify-xr]",
            xrButtonId: "data-shopify-model3d-id",
        },
        Di = {
            model:
                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
            video:
                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
            external_video:
                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
        };
    class Oi {
        constructor(t) {
            (this.section = t), (this.$container = e(t.container)), (this.selectors = ji);
        }
        init() {
            this.detectVideo(), this.detectYouTube(), this.detect3d(), this.createSlider();
        }
        createSlider() {
            var t = this;
            const i = e(ji.productSlideshow, this.$container);
            i
                .on("beforeChange", function (t, i, o) {
                    e(i.$slides[o]).find(ji.mediaSlide).trigger("pause");
                })
                .on("afterChange", function (i, o, n) {
                    const s = e(o.$slides[n]).find(ji.mediaSlide),
                        r = s[0].dataset.type,
                        a = e("body").hasClass("focus-enabled");
                    if ((s.trigger("play-desktop"), "image" === r && Pt() ? o.slickSetOption("swipe", !0, !1) : o.slickSetOption("swipe", !1, !1), "model" === r)) {
                        var l = s[0].dataset.mediaId;
                        e(ji.xrButton, t.container).attr(ji.xrButtonId, l);
                    }
                    e(".slick-dots li", this.$container).attr("aria-hidden", !1), a && s.focus();
                }),
                i.on("init", function (i, o) {
                    var n = e(o.$slides[0]).find(ji.mediaSlide)[0].dataset.type;
                    const s = t.$container.find("[data-thumbnail]");
                    e(".slick-dots li", this.$container).attr("aria-hidden", !1),
                        "image" === n && window.innerWidth < 768 && o.slickSetOption("swipe", !0, !1),
                        s
                            .on("click", function (e) {
                                e.preventDefault();
                            })
                            .on("keyup", function (t) {
                                if (13 === t.keyCode) {
                                    var i = e(this).data("media-id");
                                    e(o.$slides).filter(`[data-media-id="${i}"]`).find("model-viewer, video, iframe").eq(0).focus().select();
                                }
                            });
                }),
                i.slick({
                    focusOnSelect: !0,
                    adaptiveHeight: !0,
                    dots: !0,
                    arrows: !1,
                    accessibility: !1,
                    fade: !0,
                    swipe: !1,
                    speed: 500,
                    cssEase: "linear",
                    appendDots: e(ji.productThumbs, this.$container),
                    customPaging: function (t, i) {
                        var o = e(t.$slides[i]).find(ji.mediaSlide),
                            n = o.data("type"),
                            s = o.data("media-id"),
                            r = o.data("thumb");
                        return `<a href="${r}" class="thumb--${n}" data-thumbnail data-media-id="${s}">\n            <img alt="${o.attr("aria-label")}" src="${r}">${Di[n] ? Di[n] : ""}\n           </a>`;
                    },
                });
        }
        detect3d() {
            var t,
                i,
                o = e(ji.modelViewer, this.$container);
            if (o.length) {
                (t = o),
                    (i = this.section.id),
                    (Ai[i] = { loaded: !1 }),
                    t.each(function (t) {
                        var o = e(this),
                            n = o.data("media-id"),
                            s = e(o.find("model-viewer")[0]),
                            r = s.data("model-id");
                        0 === t && o.closest("[data-product-wrapper]").find("[data-shopify-xr]"), (xi[n] = { modelId: r, mediaId: n, sectionId: i, $container: o, $element: s });
                    }),
                    window.Shopify.loadFeatures([
                        { name: "shopify-xr", version: "1.0", onLoad: $i },
                        { name: "model-viewer-ui", version: "1.0", onLoad: Ci },
                    ]);
                const n = this;
                e(document).on("shopify_xr_launch", function () {
                    e(ji.allPlayers, n.container).trigger("pause");
                });
            }
        }
        detectVideo() {
            const e = this.section.container.querySelectorAll(ji.videoPlayerNative);
            for (var t of e) {
                const e = Pi(t.dataset.player);
                !0 === this.section.settings.enable_video_looping &&
                    e
                        .then((e) => ((e.loop = !0), e))
                        .catch((e) => {
                            console.error(e);
                        });
            }
        }
        detectYouTube() {
            const e = this.section.container.querySelectorAll(ji.videoPlayerExternal);
            for (var t of e) {
                const e = Dt(t.dataset.player);
                !0 === this.section.settings.enable_video_looping &&
                    e
                        .then((e) => Ii(e))
                        .catch((e) => {
                            console.error(e);
                        });
            }
        }
        pauseOtherMedia(t) {
            const i = e(`[data-media-slide][data-player="${t}"]`, this.container);
            e("[data-media-slide]").not(i).trigger("pause");
        }
        destroy() {
            e("[data-player]", this.container).trigger("destroy");
        }
    }
    function Ii(e) {
        return (
            e.addEventListener("onStateChange", function (e) {
                0 === e.data && e.target.playVideo();
            }),
            e
        );
    }
    const Hi = "[data-product-form]",
        Fi = "[data-product-json]",
        Bi = "[data-product-options-json]",
        zi = "[data-add-to-cart]",
        Mi = "[data-option-name]",
        Ui = "[data-add-to-cart-text]",
        Vi = "[data-product-price]",
        Wi = "[data-button-price]",
        Ri = "[data-compare-price]",
        Ni = "[data-product-slideshow]",
        Ki = "[data-product-unit-price]",
        Yi = "[data-product-base]",
        Ji = "[data-product-unit]",
        Qi = "[data-quantity-input]",
        Gi = '[name="id"]';
    var Xi = {};
    window.theme = window.theme || {};
    class Zi {
        constructor(e) {
            (this.id = e.id), (this.container = e.container), (this.settings = e.settings), (this.productFormElement = this.container.querySelector(Hi));
            const t = this.container.querySelector(Fi),
                i = this.container.querySelector(Bi);
            t && "" !== t.innerHTML ? ((this.product = JSON.parse(t.innerHTML)), (this.options = JSON.parse(i.innerHTML).options), this.init()) : console.error("Missing product JSON");
        }
        init() {
            var e, t;
            this.initializeForm(),
                this.quantitySelectors(),
                (this.hasUnitPricing = null !== this.container.querySelector(Ji)),
                this.settings.swatches_enable && this.swatchButtons(),
                this.settings.zoom_enable &&
                    ((e = this.container),
                    (t = this.product),
                    P({ url: window.theme.assets.photoswipe })
                        .then(() => {
                            const i = window.pipelinePhotoswipe.PhotoSwipe.default,
                                o = window.pipelinePhotoswipe.PhotoSwipeUI.default;
                            e.querySelectorAll("[data-zoom-button]").forEach((n) => {
                                n.addEventListener("click", (n) => {
                                    const s = e.querySelector("[data-zoom-wrapper]"),
                                        r = n.target.closest("[data-media-id]").getAttribute("data-media-id").toString(),
                                        a = [];
                                    for (let e = 0; e < t.media.length; e++) "image" === t.media[e].media_type && (a[a.length] = { src: t.media[e].src, w: t.media[e].width, h: t.media[e].height, id: t.media[e].id });
                                    const l = {
                                        index: a.findIndex((e) => e.id.toString() === r),
                                        showHideOpacity: !0,
                                        showAnimationDuration: 150,
                                        hideAnimationDuration: 250,
                                        bgOpacity: 1,
                                        spacing: 0,
                                        allowPanToNext: !1,
                                        maxSpreadZoom: 3,
                                        history: !1,
                                        loop: !0,
                                        pinchToClose: !1,
                                        modal: !1,
                                        closeOnScroll: !1,
                                        closeOnVerticalDrag: !0,
                                        getDoubleTapZoom: function (e, t) {
                                            return e ? 1.67 : t.initialZoomLevel < 0.7 ? 1 : 1.3;
                                        },
                                        getThumbBoundsFn: function () {
                                            const t = e.querySelector("[data-product-slideshow]"),
                                                i = window.pageYOffset || document.documentElement.scrollTop,
                                                o = t.getBoundingClientRect();
                                            return { x: o.left, y: o.top + i, w: o.width };
                                        },
                                    };
                                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                                    const c = new i(s, o, a, l);
                                    c.init(),
                                        c.listen("close", function () {
                                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                        });
                                });
                            });
                        })
                        .catch((e) => console.error(e))),
                this.ajaxAddListner(),
                io(Xi, this.container),
                this.customHook(Xi);
        }
        customHook(e) {
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
        }
        onOptionChange(t) {
            (function (t, i) {
                t
                    ? (t.available
                          ? (e(zi, i).removeClass("disabled").prop("disabled", !1), e(Ui, i).html(theme.strings.addToCart), e(i).removeClass("variant--soldout variant--unavailabe"))
                          : (e(zi, i).addClass("disabled").prop("disabled", !0), e(Ui, i).html(theme.strings.soldOut), e(i).removeClass("variant--unavailabe").addClass("variant--soldout")),
                      e(Vi, i).html(o.formatMoney(t.price, theme.moneyFormat)),
                      t.compare_at_price > t.price
                          ? (e(Ri, i).html(o.formatMoney(t.compare_at_price, theme.moneyFormat)), e(Ri, i).closest(".compare-at").show(), e(Vi, i).closest(".product__price").addClass("on-sale"))
                          : (e(Ri, i).closest(".compare-at").hide(), e(Vi, i).closest(".product__price").removeClass("on-sale")))
                    : (e(zi, i).addClass("disabled").prop("disabled", !0), e(Ui, i).html(theme.strings.unavailable), e(i).removeClass("variant--soldout").addClass("variant--unavailabe"));
            })((Xi = t.dataset.variant), this.container),
                this.hasUnitPricing &&
                    (function (t, i) {
                        if (void 0 !== t.unit_price) {
                            const n = o.formatMoney(t.unit_price, theme.moneyFormat),
                                s = (function (e) {
                                    return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                                })(t);
                            e(Ki, i).html(n), e(Yi, i).html(s), e(Ji, i).show();
                        } else e(Ji, i).hide();
                    })(Xi, this.container),
                io(Xi, this.container),
                to(Xi, this.container),
                (function (e, t) {
                    if (e) {
                        var i = t.querySelector(Gi);
                        i || (((i = document.createElement("input")).type = "hidden"), (i.name = "id"), this.element.appendChild(i)), (i.value = e.id.toString());
                    }
                })(Xi, this.container),
                (function (t, i) {
                    if (t) {
                        e(Mi, i).each(function () {
                            var i = e(this),
                                o = i.parents("[data-select-position]").attr("data-select-position"),
                                n = parseInt(o, 10) - 1,
                                s = t.options[n];
                            i.html(s);
                        });
                    }
                })(Xi, this.container),
                (function (t, i) {
                    var o = e("[data-remaining-count]", i),
                        n = e("[data-remaining-wrapper]", i);
                    if (!t) return void n.removeClass("variant__countdown--show");
                    if (o.length) {
                        var s = parseInt(o.attr("data-remaining-max"), 10),
                            r = "deny" === t.inventory_policy;
                        if (t.inventory_management && r) {
                            var a = t.inventory_quantity;
                            a > 0 && a <= s ? (o.html(t.inventory_quantity), n.addClass("variant__countdown--show")) : n.removeClass("variant__countdown--show");
                        } else n.removeClass("variant__countdown--show");
                    }
                })(Xi, this.container),
                (function (e) {
                    const t = window.location.href;
                    if (e && t.includes("/product")) {
                        const t = (function (e, t) {
                            return /variant=/.test(e) ? e.replace(/(variant=)[^&]+/, "$1" + t) : /\?/.test(e) ? e.concat("&variant=").concat(t) : e.concat("?variant=").concat(t);
                        })(window.location.href, e.id);
                        window.history.replaceState({ path: t }, "", t);
                    }
                })(Xi),
                this.customHook(Xi);
        }
        onQuantityChange(e) {
            to((Xi = e.dataset.variant), this.container);
        }
        ajaxAddListner() {
            e(zi, this.container).on("click", function (t) {
                if (!e("body").hasClass("focus-enabled")) {
                    t.preventDefault();
                    var i = e(this).closest("form"),
                        o = i.serializeArray();
//                     if (!i.find('[type="file"]').length) {
                        var n,
                            s = {};
                  var formdata = false;
                  if(window.FormData){
                    formdata = new FormData(i[0]);
                  }
                        e.map(o, function (e) {
                            s[e.name] = e.value;
                        }),
                            (n = s),
                            e.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: formdata ? formdata : n, contentType : false, processData : false, error: ki, success: Ei, complete: vi });
//                     }
                }
            });
        }
        swatchButtons() {
            window.theme.strings.swatchesKey
                .split(",")
                .map((e) => e.trim())
                .forEach((e) => {
                    var t = this.container.querySelector(`[data-select-label~="${e}" i]`);
                    t && this.newSwatch(e, t);
                });
        }
        async newSwatch(t, i) {
            var o,
                n,
                s,
                r,
                l = parseInt(i.getAttribute("data-select-position"), 10),
                c = `data-tooltip-${this.product.id}-${((o = 1), (n = 20), (s = Math.ceil(o)), (r = Math.floor(n)), Math.floor(Math.random() * (r - s + 1)) + s)}`;
            l--;
            var d = `<legend class="radio__legend">\n                    <span class="radio__legend__label">${t}</span>\n                    <span data-option-name>${Xi.options[l]}</span>\n                  </legend>`,
                h = this.options[l].values,
                u = document.createElement("fieldset");
            u.setAttribute("class", "radio__fieldset radio__fieldset--swatch"), (u.innerHTML = d), (i.innerHTML = null), i.appendChild(u);
            for (var p = 0; p < h.length; p++) {
                var y = h[p],
                    f = await mt(y),
                    m = f.hex;
                let e = "";
                f.path && (e = ` background-image: url('${f.path}'); background-size: cover;`);
                var g = `${t}[${y}]`,
                    w = "";
                Xi.options[l] === y && (w = "checked");
                var v = `<span class="swatch__button" ${c}>\n        <input type="radio" name="options[${t}]" value="${y}" id="${g}" ${w}>\n        <label for="${g}" style="--swatch: ${m}; ${e}" >\n          <span class="visually-hidden">${y}</span>\n        </label>\n      </span>`;
                u.innerHTML += v;
            }
            const b = this.container.querySelectorAll(`[${c}]`);
            for (let e = 0; e < b.length; e++) {
                const t = b[e],
                    i = new a({
                        target: t,
                        popover: `\n          <div class="poppy__tooltip__wrapper">\n            <div class="poppy__tooltip">\n              ${h[e]}\n            </div>\n          </div>\n        `,
                        position: "top",
                        transitionSpeed: 200,
                    });
                t.addEventListener("mouseenter", i.pin), t.addEventListener("mouseleave", i.unpin);
            }
            this.initializeForm(), e("[data-split-select-wrapper]").removeClass("selector-wrapper--placeholder");
        }
        initializeForm() {
            void 0 !== this.productForm && this.productForm.destroy(),
                (this.productForm = new ui(this.productFormElement, this.product, { onOptionChange: this.onOptionChange.bind(this), onQuantityChange: this.onQuantityChange.bind(this) }));
            try {
                Xi = this.productForm.variant();
            } catch (e) {
                Xi = this.productForm.product.variants[0];
            }
        }
        quantitySelectors() {
            e(".js-qty__adjust")
                .off()
                .on("click", function () {
                    var t = e(this),
                        i = t.siblings(".js-qty__num"),
                        o = eo(this.quantity);
                    t.hasClass("js-qty__adjust--plus") ? (o += 1) : (o -= 1) <= 1 && (o = 1), i.val(o).change(), to(Xi, this.container);
                });
        }
    }
    function eo(t) {
        var i = e(Qi, t),
            o = 1;
        return i.length && (o = parseInt(i.val().replace(/\D/g, ""), 10)), (parseFloat(o) != parseInt(o, 10) || isNaN(o)) && (o = 1), o;
    }
    function to(t, i) {
        if (t) {
            var n = eo(i),
                s = "";
            n > 1 && (s = `(${n})`);
            var r = o.formatMoney(t.price * n, theme.moneyFormat);
            e(Wi, i).html(`${r}&nbsp;${s}`);
        }
    }
    function io(t, i) {
        if (t && t.featured_media) {
            var o = e('[data-image-id="' + t.featured_media.id + '"]', i)
                .closest(".slick-slide:not(.slick-cloned)")
                .attr("data-slick-index");
            void 0 === o || e(Ni, i).slick("slickGoTo", o);
        }
    }
    B("product", {
        onLoad() {
            const t = ((i = this.container), (o = this.id), void 0 !== (n = e(i).find(`[data-settings='${o}']`).html()) ? JSON.parse(n).settings : null);
            var i, o, n;
            (this.settings = { ...t, ...window.theme.settings }), (this.productTemplate = new Zi(this)), _i(this.container), j(this.id), (this.media = new Oi(this)), this.media.init();
        },
        onUnload() {
            var t;
            (t = this.container), e("ul.tabs > li", t).off(), e(".accordion-toggle", t).off(), this.media.destroy(), this.productTemplate.destroy();
        },
        onBlockSelect(t) {
            e('*[data-block-id="' + t.detail.blockId + '"]').click();
        },
        onBlockDeselect(t) {
            e('*[data-block-id="' + t.detail.blockId + '"]').click();
        },
    });
    var oo = "[data-filters]",
        no = "[data-filters-underlay]",
        so = "data-default-hide",
        ro = "data-filters-toggle",
        ao = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        lo = "filters--visible",
        co = "filters--default-visible",
        ho = "hidden",
        uo = {};
    class po {
        constructor(t) {
            (this.$container = t), (this.$underlay = e(no, this.$container));
            const i = t.data().filters;
            (this.$filtersToggle = this._findButtons(i)), this._connectToggle(), this._onFocusOut(), this._getShowOnLoad() ? this._showFilters() : this._hideFilters();
        }
        unload() {
            this.$container.off(), this.$underlay.off(), this.$filtersToggle.off();
        }
        _connectToggle() {
            this.$filtersToggle.on(
                "click",
                function (t) {
                    "true" === e(t.currentTarget).attr("aria-expanded") ? this._hideFilters() : this._showFilters();
                }.bind(this)
            );
        }
        _onFocusOut() {
            this.$container.on(
                "focusout",
                function (t) {
                    if (!(window.innerWidth >= window.theme.sizes.medium)) {
                        var i = e(t.currentTarget).has(t.relatedTarget).length > 0,
                            o = this.$container.hasClass(lo);
                        e("body").hasClass("focus-enabled") && o && !i && this._hideFilters();
                    }
                }.bind(this)
            ),
                this.$container.on(
                    "keyup",
                    function (e) {
                        e.which === window.theme.keyboardKeys.ESCAPE && (this._hideFilters(), this.$filtersToggle.focus());
                    }.bind(this)
                ),
                this.$underlay.on(
                    "click",
                    function () {
                        this._hideFilters();
                    }.bind(this)
                );
        }
        _findButtons(t) {
            return e(`[${ro}='${t}']`);
        }
        _getShowOnLoad() {
            const t = e(`[${so}='false']`).length > 0,
                i = window.innerWidth >= window.theme.sizes.medium;
            return !(!t || !i);
        }
        _showFilters() {
            this.$container.removeClass(ho),
                setTimeout(() => {
                    this.$filtersToggle.attr("aria-expanded", !0), this.$filtersToggle.addClass(lo), this.$container.addClass(lo), this.$container.find(ao).first().focus();
                }, 1);
        }
        _hideFilters() {
            this.$filtersToggle.attr("aria-expanded", !1),
                this.$container.removeClass([lo, co]),
                this.$filtersToggle.removeClass([lo, co]),
                setTimeout(() => {
                    this.$container.hasClass(lo) || this.$container.addClass(ho);
                }, 2e3);
        }
    }
    const yo = {
            onLoad() {
                uo[this.id] = [];
                this.container.querySelectorAll(oo).forEach((t) => {
                    const i = e(t);
                    uo[this.id].push(new po(i));
                });
            },
            onUnload: function () {
                uo[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        fo = { toggle: "data-toggle-grid", large: "data-grid-large", small: "data-grid-small" },
        mo = window.theme.sizes.small;
    var go = {};
    class wo {
        constructor(e) {
            (this.$toggle = e), (this.value = this.$toggle.attr(fo.toggle)), this._listen();
        }
        unload() {
            this.$toggle.off();
        }
        _listen() {
            this.$toggle.on("click", () => {
                const t = window.innerWidth >= mo ? fo.large : fo.small;
                e(`[${t}]`).attr(t, this.value), window.lazySizes && window.lazySizes.autoSizer.checkElems();
            });
        }
        _getContianer() {
            return this.$toggle.closest("[data-section-type]").find(fo.wrapper);
        }
    }
    B("collection", [
        {
            onLoad() {
                "false" !== this.container.getAttribute("data-sort") && this.sortingClick(), this._removeUnusableFilters();
            },
            sortingClick: function () {
                Shopify.queryParams = {};
                const t = window.location;
                if (t.search.length && t.search.indexOf("sort_by"))
                    for (var i, o = 0, n = t.search.substr(1).split("&"); o < n.length; o++) (i = n[o].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(i[0])] = decodeURIComponent(i[1]));
                e("[data-sort-link]", this.$container).click(function (i) {
                    i.preventDefault(), (Shopify.queryParams.sort_by = e(this).data("value")), (t.search = e.param(Shopify.queryParams));
                });
            },
            _removeUnusableFilters() {
                e(".collection-nav--grouped", this.$container).each(function () {
                    var t = e(this).children().filter(".link--add"),
                        i = e(this).children().filter(".link--remove");
                    0 == t.length && 0 == i.length && (e(this).hide(), e(this).prev(".sidebar__heading").hide()),
                        i.length > 0 ? e(this).prev(".sidebar__heading").addClass("has-filters") : e(this).prev(".sidebar__heading").find(".link--clear").children().unwrap();
                });
            },
        },
        N,
        Ae,
        yo,
        {
            onLoad() {
                go[this.id] = [];
                this.container.querySelectorAll(`[${fo.toggle}]`).forEach((t) => {
                    const i = e(t);
                    go[this.id].push(new wo(i));
                });
            },
            onUnload: function () {
                go[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        vt,
    ]),
        B("collection-row", vt);
    var vo = {};
    function bo(e) {
        return vo[e];
    }
    (vo.basic = []),
        (vo.light = [
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "on" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (vo.light_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }, { visibility: "off" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (vo.white_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#444444" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (vo.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (vo.dark_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (vo.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
            { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: !0 }, { weight: "7.15" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.apiPromise = window.theme.apiPromise || null);
    var To = window.theme.apiPromise;
    function ko(t) {
        var i;
        return (
            null === To &&
                ((i = "https://maps.googleapis.com/maps/api/js?key=" + t),
                (To = new Promise((t, o) => {
                    e.getScript(i)
                        .done(function (e) {
                            t(e);
                        })
                        .fail(function (e) {
                            o(e);
                        });
                }))),
            To
        );
    }
    window.theme.allMaps = window.theme.allMaps || {};
    var Eo = window.theme.allMaps;
    B("index-map", {
        async onLoad() {
            var e = this.container.querySelector("[data-map-container]"),
                t = this.container.getAttribute("data-api-key");
            if (t) {
                try {
                    await ko(t);
                } catch (e) {
                    console.log(e);
                }
                var i = this.container.getAttribute("data-style") || "",
                    o = this.container.getAttribute("data-zoom") || 14,
                    n = this.container.getAttribute("data-address"),
                    s = await (function (e) {
                        return new Promise((t, i) => {
                            new google.maps.Geocoder().geocode({ address: e }, function (e, o) {
                                if ("OK" == o) {
                                    var n = { lat: e[0].geometry.location.lat(), lng: e[0].geometry.location.lng() };
                                    t(n);
                                } else i(o);
                            });
                        });
                    })(n),
                    r = { zoom: parseInt(o, 10), styles: bo(i), center: s, draggable: !0, clickableIcons: !1, scrollwheel: !1, zoomControl: !1, disableDefaultUI: !0 },
                    a = await (function (e, t) {
                        var i = new google.maps.Map(e, t),
                            o = i.getCenter();
                        return (
                            new google.maps.Marker({ map: i, position: o }),
                            google.maps.event.addDomListener(window, "resize", function () {
                                google.maps.event.trigger(i, "resize"), i.setCenter(o);
                            }),
                            i
                        );
                    })(e, r);
                Eo[this.id] = a;
            }
        },
        onUnload() {
            var e;
            (e = Eo[this.id]), void 0 !== window.google && google.maps.event.clearListeners(e, "resize");
        },
    });
    B("index-columns", {
        onLoad() {
            Ht(this.container, this.id);
        },
    });
    B("related", {
        onLoad: function () {
            var t = e(this.container),
                i = this.container,
                o = t.data("product-id"),
                n = t.data("limit"),
                s = `${window.theme.routes.product_recommendations_url || "/recommendations/products/"}?section_id=related&limit=${n}&product_id=${o}`;
            e.get(s).done(function (o) {
                var n = e(o).find("[data-related-section]").html();
                t.hide().html(n).slideDown("slow");
                i.querySelectorAll("[data-grid-swatches]").forEach((e) => {
                    gt(e).then(() => {
                        wt(e);
                    });
                });
            });
        },
    });
    const So = {
        onLoad() {
            "true" == e(this.container).attr("data-ajax-enable")
                ? (_o(), qo())
                : e(".js-qty__adjust")
                      .off()
                      .on("click", function () {
                          var t = e(this),
                              i = t.siblings(".js-qty__num"),
                              o = parseInt(i.val().replace(/\D/g, ""), 10);
                          (parseFloat(o) != parseInt(o, 10) || isNaN(o)) && (o = 1),
                              t.hasClass("js-qty__adjust--plus") ? o++ : --o <= 0 && (o = 0),
                              i.val(o).trigger("change"),
                              e("[data-update]").addClass("cart--dirty"),
                              e("[data-update]").addClass("heartBeat"),
                              setTimeout(function () {
                                  e("[data-update]").removeClass("heartBeat");
                              }, 1300);
                      });
        },
    };
    function _o() {
        e(".js-qty__adjust")
            .off()
            .on("click", function () {
                var t = e(this);
                Lo(t), Ao(parseInt(t.data("new-quantity"), 10), t.data("line-key"));
            }),
            e("[data-quantity-input]")
                .off()
                .on("change", function () {
                    var t = e(this);
                    Lo(t), Ao(parseInt(t.val(), 10), t.data("line-key"));
                });
    }
    function Lo(e) {
        e.prop("disabled", !0).parents(".js-qty").addClass("qty--disabled").end().siblings().prop("disabled", !0), e.closest(".cart__row").find(".item--loadbar").show();
    }
    function Ao(t, i) {
        let o = null,
            n = null,
            s = null;
        window
            .fetch("/cart.js")
            .then(xo)
            .then((e) => e.json())
            .then((e) => {
                const n = e.items.findIndex((e) => e.key === i);
                (o = e.item_count), (s = e.items[n].title);
                const r = { line: "" + (n + 1), quantity: t };
                return window.fetch("/cart/change.js", { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify(r) });
            })
            .then(xo)
            .then((e) => e.json())
            .then((t) => {
                var i;
                return (
                    (n = t.item_count),
                    o === n
                        ? ((i = s), Co(`<p class="h6--body strong">${window.theme.strings.stockout}</h6> <p>${i}</p>`))
                        : (e("[data-form-errors]").slideUp("fast"), document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t }, bubbles: !0 }))),
                    window.fetch("/cart?view=ajax")
                );
            })
            .then(xo)
            .then((e) => e.text())
            .then((t) => {
                e("[data-cart-form-wrapper]").empty().html(t), _o(), qo();
            })
            .catch((e) => {
                console.error(e);
                let t = "";
                void 0 !== e.status && (t = `<p class="strong">${e.status}</p>`), Co(`${t} ${e.json.description || ""}`);
            });
    }
    function xo(e) {
        return e.ok
            ? e
            : e.json().then(function (t) {
                  throw new $o({ status: e.statusText, headers: e.headers, json: t });
              });
    }
    function $o(e) {
        (this.status = e.status || null), (this.headers = e.headers || null), (this.json = e.json || null), (this.body = e.body || null);
    }
    function Co(t) {
        var i = e("[data-form-errors]");
        i.slideUp("fast"), i.empty().html(t).slideDown("fast");
    }
    function qo() {
        var t = e("[data-cart-note]");
        t.off().on("change", function () {
            var i,
                o = t.val().toString() || "";
            (i = {
                type: "POST",
                url: "/cart/update.js",
                data: "note=" + o,
                dataType: "json",
                error: function (t) {
                    var i = e("[data-form-errors]");
                    i.slideUp("fast"), i.empty().html(t.responseJSON.description).slideDown("fast");
                },
            }),
                e.ajax(i);
        });
    }
    ($o.prototype = Error.prototype),
        B("cart", So),
        e(document).ready(function () {
            z("*"),
                e("body").data("animations") && (c.init({ once: !0 }), e("body").addClass("aos-initialized")),
                document.addEventListener("lazyloaded", function (t) {
                    e(t.target).parent(".lazy-image").css("background-image", "none");
                });
            h.wrapTable({ $tables: e(".rte table"), tableWrapperClass: "rte__table-wrapper" });
            h.wrapIframe({ $iframes: e('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.rte iframe#admin_bar_iframe'), iframeWrapperClass: "rte__video-wrapper" }),
                e(document)
                    .on("mousedown", function () {
                        e("body").removeClass("focus-enabled");
                    })
                    .keyup(function (t) {
                        9 === t.keyCode && e("body").addClass("focus-enabled");
                    }),
                window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
                d.focusHash(),
                d.bindInPageLinks(),
                "scrollBehavior" in document.documentElement.style || P({ url: window.theme.assets.smoothscroll });
        });
})(
    pipelineVendor.$,
    pipelineVendor.MicroModal,
    pipelineVendor.Rellax,
    pipelineVendor.themeCurrency,
    pipelineVendor.themeImages,
    pipelineVendor.themeProductForm,
    pipelineVendor.slick,
    pipelineVendor.Poppy,
    pipelineVendor.Sqrl,
    pipelineVendor.AOS,
    pipelineVendor.a11y,
    pipelineVendor.themeRte
);
//# sourceMappingURL=theme.js.map
